import { breakpoints } from "@certn/cascadia-tokens";
import React from "react";

import { useMediaQuery } from "@certn/cascadia-react/hooks/useMediaQuery";

// @ts-ignore
import oneIdMobile from "./one-id-mobile.png";
// @ts-ignore
import oneIdWeb from "./one-id-web.png";

export const OneIdImage: React.FC = () => {
  const isMobile = useMediaQuery(
    `(max-width: ${breakpoints["breakpoint-sm"].maxWidth.toString()}px)`
  );

  return (
    <>
      {isMobile ? (
        <div>
          <img src={oneIdMobile} alt="one-id-mob" />
        </div>
      ) : (
        <div>
          <img src={oneIdWeb} alt="one-id-web" />
        </div>
      )}
    </>
  );
};
